<template>
  <div class="w-100 h-100 p-relative d-flex align-items-center">
    <div class="container container-uedahiraku ">
      <div class="row">
        <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-0">
          <b-embed
            type="iframe"
            aspect="16by9"
            :src="youtube"
            allowfullscreen
          ></b-embed>
        </div>
        <div class="col-md-10 offset-md-1 col-lg-4 offset-lg-0 pt-3 pt-md-5">
          <div>
            <h2 class="h3 font-weight-bold">作品ができるまで</h2>
            <p class="mb-md-5 text-xs-13pt">
              紙を丸めて、丸めて、セロハンテープで貼る。<br>
              そんな繰り返しが、生き物を生む。<br>
              紙とセロハンテープの重なりで作られた丸い塊は、<br class="d-none d-sm-block">
              何かの卵のように硬い。<br>
              <br>
              紙を丸めて、丸めて、セロハンテープで貼る。<br>
              そんな繰り返しが、生き物を生む。
            </p>
            <a href="https://forms.gle/cqhke69hh2S5xMqD9" target="_blank" class="btn btn-outline-dark font-weight-bold border-2px">
              オーダーはコチラへ
            </a>

          </div>
        </div>
      </div>
    </div><!-- /.container -->
    <h2 class="right-title futura tracking-1">ART PROCESS</h2>
    <div class="right-item">
      <div class="tategaki font-weight-bold">
        作品ができるまで
      </div>
    </div>
    <img class="d-none d-lg-block tissue-bg tissue-bg-1" src="@/assets/images/top/tissue-1v.png">
    <img class="d-none d-lg-block tissue-bg tissue-bg-3" src="@/assets/images/top/tissue-3.png">
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UntilWorkIsMade',
  data() {
    return {
      isMounted: false,
      youtubeUrl: 'https://www.youtube.com/embed/fNEsPnKDy8E'
    }
  },
  mounted() {
    this.isMounted = true,
    this.setPageControl({lightTheme: false, left: false, right: false, up: true, down: true})
  },
  computed: {
    youtube() {
      if (!this.isMounted) return ''
      else return this.youtubeUrl
    }
  },
  methods: {
    ...mapActions({
      setPageControl: 'doSetPageControl'
    })
  }
}
</script>

<style lang="scss">
.embed-responsive {
  background-color: #eee; 
}
</style>

<style lang="scss" scoped>
.text-xs-13pt {
  @media screen and (max-width: 576px){
    font-size: 13px;
  }
}
.tissue-bg {
  mix-blend-mode: multiply;
  position: absolute;
  opacity: 0.8;
}
.tissue-bg-1 {
  top: -200px;
  right: 0;
  width: 70px;
}

.tissue-bg-3 {
  top: -260px;
  left: 300px;
  width: 400px;
}
</style>